<template>
  <div>
    <div>
      <div style="text-align:center;background-color: #000;">
        <video autoplay preload="auto" controls="controls" oncontextmenu="return false;" style="display:block; width: 100%; height: 420px;">
          <source v-for="(item, index) in infoList" :key="index" :src="item.playURL" :type="'video/'+item.format">
        </video>
      </div>
    </div>
  </div>
</template>

<script>
import { getFormData } from "@/api/api";
import { getAuthVideoInfo } from "@/api/url"

export default {
  name: "VideoPlay",
  props: {
    value: Object
  },
  data() {
    return {
      videoId: this.value.videoId,
      infoList: []
    }
  },
  methods: {
    getVideo() {
      getFormData(getAuthVideoInfo, {videoId: this.videoId}).then((data) => {
        let {code, msg} = data;
        if (code == 200) {
          this.infoList = data.data;
        } else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      }).catch(() => {

      })
    }
  },
  mounted() {
    this.getVideo()
  }
}
</script>

<style scoped>

</style>
